// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// // Define the form data type
// export interface DataBreachFormData {
//   id?: string;
//   date_of_incident: string;
//   time_of_incident: string;
//   location_of_incident: string;
//   type_of_data: string;
//   other_type_of_data?: string;
//   description: string;
//   individuals_affected: string;
//   contact_info: string;
//   immediate_actions: string;
//   breach_reported_externally: string;
//   reported_to?: string;
//   prevention_recommendations: string;
//   reporter_name: string;
//   resolved: string;
//   signature: string;
//   date_completed: string;
//   photo?: File | string;
//   client_email?: string;
// }

// // Define the state type
// export interface DataBreachState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: DataBreachState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Helper function to convert file to base64
// const convertFileToBase64 = (file: File): Promise<string> => {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//     reader.readAsDataURL(file);
//   });
// };

// // Async thunk for posting data breach report
// export const submitDataBreach = createAsyncThunk<
//   { message: string },
//   DataBreachFormData,
//   { rejectValue: string }
// >('dataBreach/submitDataBreach', async (formData, { rejectWithValue, dispatch }) => {
//   try {
//     // Retrieve data from localStorage
//     const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//       projectId?: string;
//     };
//     const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//       selectedServiceTitle?: string;
//     };
//     const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//       email?: string;
//     };
//     const client_email = selectedClient.email || '';

//     if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//       return rejectWithValue('Missing project, service, or client information in localStorage');
//     }

//     let photoField: string = '';
//     if (formData.photo instanceof File) {
//       photoField = await convertFileToBase64(formData.photo);
//     } else if (typeof formData.photo === 'string') {
//       photoField = formData.photo;
//     }

//     const payload = {
//       id: formData.id,
//       group_id: project.projectId,
//       service_name_id: service.selectedServiceTitle,
//       client_email,
//       date: formData.date_of_incident,
//       time: formData.time_of_incident,
//       location: formData.location_of_incident,
//       type_of_data:
//         formData.type_of_data === 'Other'
//           ? formData.other_type_of_data || ''
//           : formData.type_of_data,
//       description: formData.description,
//       individuals_affected: formData.individuals_affected,
//       contact_info: formData.contact_info,
//       immediate_actions: formData.immediate_actions,
//       breach_reported_externally: formData.breach_reported_externally,
//       reported_to: formData.reported_to || '',
//       prevention: formData.prevention_recommendations,
//       reporter_name: formData.reporter_name,
//       resolved: formData.resolved,
//       signature: formData.signature,
//       date_completed: formData.date_completed,
//       photo: photoField
//     };

//     const response = await axiosInstance.post('/ndis/form/data-breach', payload, {
//       headers: { 'Content-Type': 'application/json' }
//     });
//     await dispatch(fetchIncidents({ client_email })).unwrap();
//     return response.data;
//   } catch (error: any) {
//     return rejectWithValue(error.response?.data?.message || 'Failed to submit data breach report');
//   }
// });

// const dataBreachSlice = createSlice({
//   name: 'dataBreach',
//   initialState,
//   reducers: {
//     clearDataBreachState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitDataBreach.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitDataBreach.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Data breach reported successfully';
//         state.error = null;
//       })
//       .addCase(submitDataBreach.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearDataBreachState } = dataBreachSlice.actions;
// export default dataBreachSlice.reducer;



import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchIncidents } from '../carporateServices/IncidentsListSlice';

// Define the form data type
export interface DataBreachFormData {
  id?: string;
  date_of_incident: string;
  time_of_incident: string;
  location_of_incident: string;
  type_of_data: string;
  other_type_of_data?: string;
  description: string;
  individuals_affected: string;
  contact_info: string;
  immediate_actions: string;
  breach_reported_externally: string;
  reported_to?: string;
  prevention_recommendations: string;
  reporter_name: string;
  resolved: string;
  signature: string;
  date_completed: string;
  photo?: File | string;
  client_email?: string;
}

// Define the state type
export interface DataBreachState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: DataBreachState = {
  loading: false,
  message: null,
  error: null
};

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Async thunk for posting data breach report
export const submitDataBreach = createAsyncThunk<
  { message: string },
  DataBreachFormData,
  { rejectValue: string }
>('dataBreach/submitDataBreach', async (formData, { rejectWithValue, dispatch }) => {
  try {
    // Retrieve data from localStorage
    const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
      projectId?: string;
    };
    const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
      selectedServiceTitle?: string;
    };
    const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
      email?: string;
    };
    const client_email = selectedClient.email || '';

    if (!project.projectId || !service.selectedServiceTitle || !client_email) {
      return rejectWithValue('Missing project, service, or client information in localStorage');
    }

    let photoField: string = '';
    if (formData.photo instanceof File) {
      photoField = await convertFileToBase64(formData.photo);
    } else if (typeof formData.photo === 'string') {
      photoField = formData.photo;
    }

    const payload = {
      id: formData.id,
      group_id: project.projectId,
      service_name_id: service.selectedServiceTitle,
      client_email,
      date: formData.date_of_incident,
      time: formData.time_of_incident,
      location: formData.location_of_incident,
      type_of_data:
        formData.type_of_data === 'Other'
          ? formData.other_type_of_data || ''
          : formData.type_of_data,
      description: formData.description,
      individuals_affected: formData.individuals_affected,
      contact_info: formData.contact_info,
      immediate_actions: formData.immediate_actions,
      breach_reported_externally: formData.breach_reported_externally,
      reported_to: formData.reported_to || '',
      prevention: formData.prevention_recommendations,
      reporter_name: formData.reporter_name,
      resolved: formData.resolved || '',
      signature: formData.signature,
      date_completed: formData.date_completed,
      photo: photoField
    };

    const response = await axiosInstance.post('/ndis/form/data-breach', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    await dispatch(fetchIncidents({ client_email })).unwrap();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to submit data breach report');
  }
});

const dataBreachSlice = createSlice({
  name: 'dataBreach',
  initialState,
  reducers: {
    clearDataBreachState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitDataBreach.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitDataBreach.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Data breach reported successfully';
        state.error = null;
      })
      .addCase(submitDataBreach.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearDataBreachState } = dataBreachSlice.actions;
export default dataBreachSlice.reducer;